import {HiOutlineMail} from 'react-icons/hi'
import {FaWhatsapp} from 'react-icons/fa'
//import {RiMessengerLine} from 'react-icons/ri'

const data = [
    {id: 1, icon: <HiOutlineMail/>, link: 'mailto:subha81788@gmail.com'},
    {id: 2, icon: <FaWhatsapp/>, link: 'https://wa.me/+919836885448'},
    //{id: 3, icon: <RiMessengerLine/>, link: 'https://www.messenger.com/t/100087217880007'},
]


// alternative whatsApp link
// https://wa.me/yournumber
// https://api.whatsapp.com/send/?phone=%2B9836885448


export default data